<template>
  <div
    id="crm-baisc-config"
    v-loading.fullscreen="loading"
    class="app-main-content"
    element-loading-text=""
    element-loading-spinner="none"
    element-loading-background="rgba(170,170,170,0)"
    style="flex-grow:1;display:flex;flex-direction:column"
  >
    <div class="app-main-inner-tab" style="flex-grow:1;display:flex;flex-direction:column">
      <el-tabs v-model="activeTabName" type="card" style="width:100%">
        <el-tab-pane :label="$t('Menu.BasicData')" name="basicData">
          <basic-data />
        </el-tab-pane>
        <el-tab-pane :lazy="true" :label="$t('Menu.ExpiredCustomerNotification')" name="customerNotificationConfiguration">
          <customer-notification-configuration />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import BasicData from '@/views/cargo/v0/Sales/components/CrmSetting/basicData.vue'
import CustomerNotificationConfiguration from '@/views/cargo/v0/SystemMaintenance/components/basicConfig/customerNotificationConfiguration.vue'
import { SalesUtil } from '@/class/cargo/model/utils/SalesUtil'

export default {
  name: 'CRMSetting',
  components: { BasicData, CustomerNotificationConfiguration },
  data() {
    return {
      loading: false,
      activeTabName: 'basicData'
    }
  },
  mounted() {
    SalesUtil.checkCrmExpire(this.$route, this.$router)
  }
}
</script>

<style lang="scss">
#app #baisc-config .app-main-page{
  height: calc(100vh - 100px);
}
#baisc-config {
  .el-tabs {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    .el-tabs__content {
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      .el-tab-pane {
        flex-grow: 1;
        display: flex;
        flex-direction: column;
      }
    }
  }
}
</style>
